import React from "react";
import PropTypes from "prop-types";
import Course from "./Course";

const Courses = ({ courseList, changeNames }) => {

    return (
      <div className="course-code">
        <h3>Course Code</h3>
        {courseList.map((course, index) => (
          <Course course={course} key = {index} changeNames = {changeNames}/>
        ))}
      </div>
    );
  

};

Courses.propTypes = {};

export default Courses;
